import { SectionHeader } from "@/theme1/components/common/SectionHeader";
import RecommendationCarousel from "@/theme1/components/recommendations/RecommendationCarousel";

export default function RecentlyViewed({ products }) {
  return (
    <section className="space-y-8">
      <SectionHeader
        eyebrow="Recently Viewed"
        title="Continue exploring."
        description="Products you viewed recently, ready to compare and revisit."
      />
      <RecommendationCarousel products={products} />
    </section>
  );
}